import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=15cee780&lang=scss&scoped=true"

import exportComponent from "C:\\wisata-jepara-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15cee780"]])

export default __exports__